export interface AddressFormValues {
  streetAddress: string;
  unit: string;
  city: string;
  country: string;
  postCode: string;
  formattedAddress: string;
}

export const updateForm = (
  e: React.ChangeEvent<HTMLInputElement>,
  setFormValues: React.Dispatch<React.SetStateAction<AddressFormValues>>,
) => {
  const { name, value } = e.target;
  setFormValues(prev => ({ ...prev, [name]: value }));
};

export const checkForError = (
  fieldName: keyof AddressFormValues,
  formValues: AddressFormValues,
) => {
  return !formValues[fieldName].trim();
};

export const handleSubmit = (
  formValues: AddressFormValues,
  onSave?: (values: AddressFormValues) => void,
) => {
  if (onSave) {
    // Convert empty strings to undefined. The parent component expects empty values to be undefined.
    const cleanedValues = Object.fromEntries(
      Object.entries(formValues).map(([key, value]) => [key, value === '' ? undefined : value]),
    ) as AddressFormValues;
    onSave(cleanedValues);
  }
};
